<template>
  <div style="position: relative">
    <div class="f-down-login">
      <div class="f-down-left">
        <div class="h-btitle">睿泽CRM永久免费，不限人数</div>
        <div class="hs-title">您只需支付较低的价格，即可享受人力资源、财务模块功能</div>
        <div class="h-stitle f-down-stitle">
            睿泽云是一款SAAS云端CRM、HRM、财务管理的综合管理系统<br>
            众多企业在睿泽云的帮助下实现企业全流程数字化管理
        </div>
        <div class="extra-wrap">
          <img src="@/assets/v1/main-banner.png" alt="" class="computer-icon">
        </div>
      </div>
    </div>
    <div class="module-type">
      <div class="base-title" style="margin-bottom: 70px">
        <div class="btitle">睿泽云能为您做什么？</div>
        <div class="stitle" style="margin-bottom: 0px">
          为您的企业提供业务支持、人资优化、财物调配、供应链管理、知识共享等由内而外一体化的数字化办公应用。<br />
          每个产品的功能都足够强大，当它们协同配合时，您将体会到前所未有的数字化能量。
        </div>
      </div>
      <div class="three-type row-center-left" style="flex-wrap: wrap">
        <div class="module-block">
          <div class="module-block-top">
            <div class="block-top-title row-left">
              <img src="@/assets/v1/crm.png" alt="" class="title-icon" />
              <span class="top-desc">客户管理 CRM</span>
            </div>
            <div class="block-top-desc">
              销售管理帮助企业实现市场营销、销售、服务的流 <br />
              程化，管理的自动化，客户价值与企业收益的最大 <br />
              化。
            </div>
          </div>
          <div class="module-block-main">
            <span class="block-main-item"> 线索管理 </span>
            <span class="block-main-item"> 客户管理 </span>
            <span class="block-main-item"> 商机管理 </span>
            <span class="block-main-item"> 合同管理 </span>
            <span class="block-main-item"> 回款管理 </span>
            <span class="block-main-item"> OA协同 </span>
          </div>
        </div>
        <div class="module-block">
          <div class="module-block-top">
            <div class="block-top-title row-left">
              <img src="@/assets/v1/hrm.png" alt="" class="title-icon" />
              <span class="top-desc">人资管理 HRM</span>
            </div>
            <div class="block-top-desc">
              人力资源管理帮助企业有效推进人力资源的调整和<br />
              优化，动态把握员工信息，实时调整人才战略，助<br />
              力企业长远发展。
            </div>
          </div>
          <div class="module-block-main">
            <span class="block-main-item"> 招聘管理 </span>
            <span class="block-main-item"> 员工管理 </span>
            <span class="block-main-item"> 考勤管理 </span>
            <span class="block-main-item"> 薪资管理 </span>
            <span class="block-main-item"> 社保管理 </span>
            <span class="block-main-item"> 绩效管理 </span>
            <span class="block-main-item"> 员工自助 </span>
          </div>
        </div>
        <div class="module-block">
          <div class="module-block-top">
            <div class="block-top-title row-left">
              <img src="@/assets/v1/fs.png" alt="" class="title-icon" />
              <span class="top-desc">财务管理 FS</span>
            </div>
            <div class="block-top-desc">
              以企业财务管理人员为主，提供全面财务管理功<br />
              能。无缝对接睿泽CRM系统，实现客户-销售-库<br />
              存-财务一体化智能管理。
            </div>
          </div>
          <div class="module-block-main">
            <span class="block-main-item"> 凭证管理 </span>
            <span class="block-main-item"> 账簿管理 </span>
            <span class="block-main-item"> 财务报表 </span>
            <span class="block-main-item"> 辅助核算 </span>
            <span class="block-main-item"> 快捷结账 </span>
            <span class="block-main-item"> 精细化科目管理 </span>
          </div>
        </div>
        <div class="module-block">
          <div class="module-block-top">
            <div class="block-top-title row-left">
              <img src="@/assets/v1/jxc.png" alt="" class="title-icon" />
              <span class="top-desc">进销存管理</span>
            </div>
            <div class="block-top-desc">
              全面实现采购、产品、销售、库存与财务的专业<br />
              管理，助您以最小的管理成本达到最大的生意效<br />
              益。
            </div>
          </div>
          <div class="module-block-main">
            <span class="block-main-item"> 采购管理 </span>
            <span class="block-main-item"> 产品管理 </span>
            <span class="block-main-item"> 销售管理 </span>
            <span class="block-main-item"> 库存管理 </span>
            <span class="block-main-item"> 财务管理 </span>
          </div>
        </div>
        <div class="module-block">
          <div class="module-block-top">
            <div class="block-top-title row-left">
              <img src="@/assets/v1/zsk.png" alt="" class="title-icon" />
              <span class="top-desc">知识库</span>
            </div>
            <div class="block-top-desc">
              成员知识沉淀与经验交互的高效利器，有效调动企<br />
              业知识软财富，提高生产创造力<br />
            </div>
          </div>
          <div class="module-block-main">
            <span class="block-main-item"> 无限存储 </span>
            <span class="block-main-item"> 无限编辑 </span>
            <span class="block-main-item"> 多人协作 </span>
            <span class="block-main-item"> 全员共享 </span>
            <span class="block-main-item"> 多端同步 </span>
            <span class="block-main-item"> 一级兼容 </span>
            <span class="block-main-item"> 权限控制 </span>
            <span class="block-main-item"> 个性标注 </span>
          </div>
        </div>
        <div class="module-block">
          <div class="module-block-top">
            <div class="block-top-title row-left">
              <img src="@/assets/v1/scrm.png" alt="" class="title-icon" />
              <span class="top-desc">睿泽SCRM</span>
            </div>
            <div class="block-top-desc">
              睿泽SCRM全面对接企业微信、打造基于社交生态<br />的动态客户管理系统。
            </div>
          </div>
          <div class="module-block-main">
            <span class="block-main-item"> 获取渠道 </span>
            <span class="block-main-item"> 销售管理 </span>
            <span class="block-main-item"> 客户运营 </span>
            <span class="block-main-item"> 裂变传播 </span>
            <span class="block-main-item"> 运营管理 </span>
          </div>
        </div>
      </div>
    </div>
    <choice />
    <div class="solutionframe">
      <div class="innerframe">
        <carousel2 />
      </div>
    </div>
    <cooperation />
    <understand />
    <div class="app-wrap" style="padding-bottom: 0px">
      <div class="txt-pic">
        <div class="txt-wrap left-txt" style="text-align: left">
          <div class="txt-btitle">支持移动办公</div>
          <div class="txt-stitle">
            睿泽移动端助力客户管理CRM、人资管理HRM、财务管理FS，<br />
            并全面支持Andorid、IOS系统，无缝接入企业微信与钉钉，<br />
            实现多系统数据实时互通，随时随地多设备办公。
          </div>
        </div>
        <div class="pic-wrap">
          <img src="@/assets/v1/app.png" alt="" class="pic-el" />
        </div>
      </div>
    </div>
    <div class="app-wrap">
      <div class="txt-pic">
        <div class="pic-wrap">
          <img src="@/assets/v1/dingding.png" alt="" class="pic-el" />
        </div>
        <div class="txt-wrap left-txt" style="text-align: right">
          <div class="txt-btitle">
            与企业微信、钉钉实施互通<br />
            私域流量尽在掌控
          </div>
          <div class="txt-stitle">
            客户引流、同步聊天记录、客户sop、会话审计、群运营、<br />
            智能话术等功能，打造基于社交生态的动态客户管理系统。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import carousel2 from './planswiper'
import choice from '@/components/choice'
import understand from '@/components/understand'
import cooperation from '@/components/cooperation'

export default {
  name: 'index',
  components: { carousel2, choice, understand, cooperation },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.f-down-login {
  width: 1200px;
  margin: 20px auto 0;
  padding: 50px 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start ;
  position: relative;
}
.f-down-left {
  width: 1200px;
  margin-top: 20px;
}
.h-btitle {
  color: #172B4D;
  font-size: 42px;
  line-height: 60px;
}
.hs-title {
  margin-top: 10px;
  color: #42526E;
  font-size: 18px;
}
.h-stitle {
  line-height: 30px;
  font-size: 20px;
  color: #42526E;
}
.f-down-stitle {
  margin: 10px 0 20px;
}
.extra-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}
.free-use {
  padding: 15px 30px;
  background-color: #0252CC;
  border-radius: 3px;
  color: #fff;
  margin-bottom: 50px;
}
.computer-icon {
  width: 80%;
  margin: 0 auto;
}
.module-type {
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #fff;
  text-align: left;
}
.base-title {
  width: 100%;
  text-align: center;
}
.btitle {
  font-size: 36px;
  line-height: 50px;
  color: #172B4D;
  text-align: center;
}
.stitle {
  text-align: center;
  font-size: 16px;
  color: #42526E;
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 70px;
}
.three-type {
  width: 1200px;
  margin: 0 auto;
}
.row-center-left {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}
.three-type .module-block {
  margin: 0 10px;
  width: 380px;
  background: linear-gradient(135deg, #F4F5F7 0%, #FFFFFF 100%);
  box-shadow: 0px 2px 12px 0px #D7DBDF;
  border-radius: 3px;
  margin-bottom: 30px;
}
.module-block-top {
  margin-bottom: 10px;
  padding: 20px;
  margin-bottom: 5px;
  background: url(~@/assets/v1/why-bg.png) 100% 100% no-repeat;
}
.module-block-top .block-top-title {
  margin-bottom: 10px;
}
.module-block-main {
  background-color: #fff;
  padding: 30px 20px;
}
.module-block-main .block-main-item {
  line-height: normal;
  font-size: 14px;
  text-align: center;
  border: 1px solid #DFE1E6;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 5px;
  margin-right: 7px;
  display: inline-block;
  color: #6B778C;
}
.preview-detail .detail {
  width: 100%;
  cursor: pointer;
  display: block;
  color: #fff;
  text-align: center;
  background-color: #0252CC;
  border-radius: 3px;
  padding: 10px;
  margin: 10px 0;
}
.top-desc {
  color: #253858;
  font-size: 20px;
}
.wk-btn {
  padding: 15px 30px;
  background-color: #0252CC;
  border-radius: 3px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
}
.big-btn {
  width: 100%;
  line-height: normal;
  color: #fff !important;
  display: block;
  text-align: center;
  margin-top: 15px;
}
.title-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  vertical-align: middle;
  display: inline-block;
  border: none;
}
.block-top-desc {
  color: #42526E;
  min-height: 72px;
  font-size: 14px;
  line-height: 24px;
  text-align: justify;
}
.app-wrap {
  background-color: #fff;
  padding-top: 60px;
  padding-bottom: 60px;
}
.txt-pic {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.txt-pic .txt-wrap {
  width: 50%;
}
.txt-pic .pic-wrap {
  width: 50%;  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.left-txt {
  justify-content: center;
}
.right-txt {
  text-align: center;
  justify-content: center;
}
.txt-wrap .txt-btitle {
  color: #172B4D;
  font-size: 36px;
  margin-bottom: 20px;
}
.txt-wrap .txt-stitle {
  color: #42526E;
  font-size: 16px;
  line-height: 24px;
}
.txt-pic .pic-wrap .pic-el {
  width: 100%;
  display: inline-block;
  border-radius: 3px;
}
.small-title {
  color: #6B778C;
  font-size: 24px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage.vue